module.exports = __webpack_public_path__ + "img/car-panel.d223ec8b.png";